class CreateAppointmentRequestReq{
    constructor(){
        this.FirstPrioTime = null;
        this.SecondPrioTime = null;
        this.ThirdPrioTime = null;
        this.Notes = null;
        this.AccountingSessionId = null;
        this.PatientId = null;
        this.AppointmentId = null;
        this.AppointmentMade = null;
        this.pagingParams ={
            pageSize: 100,
            pageNumber: 1
        }
    }
}
export default CreateAppointmentRequestReq;